export const USER_CREATION_BULK_UPLOAD_LIMIT = 20;

export const USER_CREATION_UPLOAD_CONFIRM_TITLE = 'Before you upload';

export const getUserCreationUploadConfirmMessage = (
  limit = USER_CREATION_BULK_UPLOAD_LIMIT
): string =>
  `Only up to ${limit} users can be created per upload.
   There is no limit on the number of records uploaded without user creation.`;
